import {ICard} from "@/model/materials/cards";
import {api} from "@/lib/api";
import {session} from "@/model/session";
import {reactive} from "vue";

const cvs = document.createElement('canvas')
const ctx = cvs.getContext('2d');

export class CardPreview {
    readonly active = reactive({header: '', content: '', footer: '', loaded: false, loading: false})

    constructor(readonly data: ICard) {
        this.active.header = data.header_image_url
        this.active.footer = data.footer_image_url
    }

    async render(): Promise<void> {
        if (this.active.loaded) {
            this.active.loading = false
            return Promise.resolve();
        }
        if (!ctx) return Promise.reject('canvas 2D unavailable');
        if (!session.agent) return Promise.reject('not login');
        this.active.loading = true
        this.active.header = ''
        this.active.content = ''
        return api<void, Blob>({
            url: `user/${session.agent.meta.account.agent_id}/activity/card`,
            method: 'POST',
            data: {...this.data, title: '测试标题', material_image_url: ''},
            responseType: 'blob'
        }).then(async result => {
            if (!ctx) return Promise.resolve();
            this.active.header = window.URL.createObjectURL(result)
            // 开始通过header计算content
            const ib = await createImageBitmap(result)
            cvs.width = ib.width
            cvs.height = ib.height
            ctx.drawImage(ib, 0, 0)
            const id = ctx.getImageData(0, ib.height - 1, ib.width, 1)
            if (!id) return
            cvs.height = 1
            ctx.putImageData(id, 0, 0)
            this.active.content = cvs.toDataURL('image/png', 0.7)
            this.active.loaded = true
        }).finally(() => {
            this.active.loading = false
        })
    }

    async prepare() {
        if (!ctx) return Promise.resolve();
        // 开始通过header计算content
        const response = await fetch(this.data.header_image_url);
        const blob = await response.blob();
        const ib = await createImageBitmap(blob)
        cvs.width = ib.width
        cvs.height = ib.height
        ctx.drawImage(ib, 0, 0)
        const id = ctx.getImageData(0, ib.height - 1, ib.width, 1)
        if (!id) return
        cvs.height = 1
        ctx.putImageData(id, 0, 0)
        this.active.content = cvs.toDataURL('image/png', 0.7)
    }
}